import React, {useState,useEffect} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Stack } from '@mui/material';
import * as calc from '../utils/calcolatrice'
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BasicTable(props) {

    const {ruota,corona, rpm, binary = false, pignoni,setPignoni,invertiCalcolo, en} = props
    const {
        p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,
        setP1,setP2,setP3,setP4,setP5,setP6,setP7,setP8,setP9,setP10,setP11,setP12,setP13,setP14
      } = props

    
    const [rows,setRows] = useState([])

    const msToKmh = (speedMs) => (speedMs * 3600) / 1000;

    const generaRighe = (pignoni,ruota,corona,rpm,binary = false) => {


        return pignoni.map(pignone => {

            let rapporto = 1//(binary) ? (corona/pignone)/1.25 : (invertiCalcolo) ? (corona/pignone)*1.25 : (corona/pignone)

            if(invertiCalcolo) {
                rapporto = (binary) ? (corona/pignone)*1.25  : (corona/pignone)
            }
            else {
                rapporto = (binary) ? (corona/pignone)/1.25  : (corona/pignone)
            }

            const sviluppo = ruota.sviluppo
            const speed = msToKmh(calc.calcSpeedByRpmSprocketsWheelCircumference(rpm,rapporto,sviluppo,binary))


            return {sviluppo: (Math.round((rapporto*sviluppo))/1000), speed,pignone}
            

        })


    }

    const deletePignone = (pignone) => {

        console.log(pignone)
        if(!pignone || isNaN(pignone) || pignone < 1) return

        if(Number(p1) === Number(pignone)) setP1('')
        else if(Number(p2) === Number(pignone)) setP2('')
        else if(Number(p3) === Number(pignone)) setP3('')
        else if(Number(p4) === Number(pignone)) setP4('')
        else if(Number(p5) === Number(pignone)) setP5('')
        else if(Number(p6) === Number(pignone)) setP6('')
        else if(Number(p7) === Number(pignone)) setP7('')
        else if(Number(p8) === Number(pignone)) setP8('')
        else if(Number(p9) === Number(pignone)) setP9('')
        else if(Number(p10) === Number(pignone)) setP10('')
        else if(Number(p11) === Number(pignone)) setP11('')
        else if(Number(p12) === Number(pignone)) setP12('')
        else if(Number(p13) === Number(pignone)) setP13('')
        else if(Number(p14) === Number(pignone)) setP14('')

        
        /* setTimeout(() => {
            setPignoni([...pignoni.filter(el => el !== Number(pignone)).sort()])

        },100) */
    }


    useEffect(() => {
        setRows(generaRighe(pignoni,ruota,corona,rpm,binary))

    },[ruota,corona, rpm,pignoni])

  return (
    <Stack spacing={2}>
        <div>
            {!binary && <div style={{marginBottom: '20px'}}>
                            {invertiCalcolo ? <h4>{en ? "Chainring - Speed 1" : "Corona - Velocità 1"}: {Math.round(corona)}</h4> : <h4>{en ? "Chainring - Without binary system" : "Corona - senza sistema"}: {Math.round(corona)}</h4>}
                        </div>}
            {binary && <div>
                {invertiCalcolo ? <h4>{en ? "Chainring - Speed 2" : "Corona - Velocità 2"}: {Math.round(corona*1.25)}</h4> : <h4>{en ? "Chainring - With Binary system" : "Corona - con sistema Binary"}: {Math.round(corona/1.25)}</h4>}
                {!invertiCalcolo && <small>{en ? "Chainring to use on your bike" : "Corona da montare fisicamente sulla bici."}</small>}
            </div>}  
        </div>
        <TableContainer component={Paper} style={{marginRight: '5px'}}>
        <Table sx={{ minWidth: 550 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell align="center">{en ? "Sprocket" : "Pignone"}</TableCell>
                <TableCell align="center">{en ? "Speed" : "Velocità"}</TableCell>
                <TableCell align="center">{en ? "Dist. per stroke" : "Sviluppo Metrico"}</TableCell>
                <TableCell align="center"></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {rows.map((row,index) => (
                <TableRow
                key={index}
                >
                <TableCell align="center">{row.pignone}</TableCell>
                <TableCell align="center">{row.speed > 0 ? row.speed.toFixed(2) + ' Km/h' : '-'}</TableCell>
                <TableCell align="center">{row.sviluppo.toFixed(3)} m</TableCell>
                <TableCell align="center">
                    <IconButton onClick={() => {
                        deletePignone(row.pignone)
                    }}>
                        <DeleteIcon/>
                    </IconButton>
                </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </TableContainer>
    </Stack>
  );
}